import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const backgroundImages = [
    '/images/hero2.jpeg',
    '/images/hero1.jpeg',
    '/images/hero3.jpeg',
    '/images/hero4.jpeg'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 7000);

    return () => clearInterval(interval);
  }, [backgroundImages.length]); // Fixed: added dependency

  return (
    <section className="hero" id="home">
      <div className="hero-background">
        <AnimatePresence>
          <motion.div
            key={currentImageIndex}
            className="hero-bg-image"
            initial={{ scale: 1.2, x: '-10%', opacity: 0 }}
            animate={{ scale: 1, x: '0%', opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2, ease: "easeOut" }}
            style={{
              backgroundImage: `url(${backgroundImages[currentImageIndex]})`,
            }}
          />
        </AnimatePresence>
      </div>

      <div className="container">
        <motion.div 
          className="hero-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* Your content here */}
        </motion.div>
      </div>

      <div className="slider-indicators">
        {backgroundImages.map((_, index) => (
          <button
            key={index}
            className={`indicator ${currentImageIndex === index ? 'active' : ''}`}
            onClick={() => setCurrentImageIndex(index)}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;